export const kpiTabs = [
  { label: 'This Week', value: 'week'},
  { label: '1 Month', value: 'month'}, 
  { label: '2 Months', value: '2 months'}, 
  { label: '6 Months', value: '6 months'}, 
  { label: 'Year', value: 'year' }, 
  { label: 'Custom', value: 'custom' }
]